import { type BadgeProps, DesignSystemBadge } from '@mathflat/design-system-2024'
import { type ComponentPropsWithRef, forwardRef } from 'react'

interface Props
  extends ComponentPropsWithRef<typeof DesignSystemBadge>,
    Pick<
      BadgeProps,
      'radius' | 'color' | 'backgroundColor' | 'borderColor' | 'size' | 'children'
    > {}

export const Badge = forwardRef<HTMLSpanElement, Props>(
  ({ children, color, backgroundColor, borderColor, size, radius }, ref) => {
    return (
      <DesignSystemBadge
        ref={ref}
        backgroundColor={backgroundColor}
        color={color}
        borderColor={borderColor}
        size={size}
        radius={radius}
      >
        {children}
      </DesignSystemBadge>
    )
  },
)

Badge.displayName = 'Badge'
